// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"d6dfea74","177":"5ea7b51b","258":"fb918080","586":"41f8b523","743":"780701ac","848":"8895ce44","943":"cc9570f8"}[chunkId] + ".chunk.css";
};